import { interceptAxiosWithDiagnostics as interceptSharedAxiosWithDiagnostics } from '@patsnap/synapse_common_utils'
import type { DiagnosticEventSink } from '@patsnap/synapse_common_utils'
import type { AxiosInstance } from 'axios'

const axiosDisposers = new Map<AxiosInstance, () => void>()
let diagnosticsEnabled = false
let diagnosticEventSink: DiagnosticEventSink | undefined

export function configureAxiosDiagnosticSink(sink?: DiagnosticEventSink): void {
  diagnosticEventSink = sink
}

export function interceptAxiosWithDiagnostics(axiosInstance: AxiosInstance): void {
  if (axiosDisposers.has(axiosInstance)) return
  axiosDisposers.set(
    axiosInstance,
    interceptSharedAxiosWithDiagnostics(axiosInstance, (event) => {
      if (diagnosticsEnabled) diagnosticEventSink?.(event)
    })
  )
}

export function setAxiosDiagnosticsEnabled(enabled: boolean): void {
  diagnosticsEnabled = enabled
}
